import { render } from "./IFSModal.vue?vue&type=template&id=300d4346&scoped=true"
import script from "./IFSModal.vue?vue&type=script&lang=js"
export * from "./IFSModal.vue?vue&type=script&lang=js"

import "./IFSModal.vue?vue&type=style&index=0&id=300d4346&lang=scss&scoped=true"
import "./IFSModal.vue?vue&type=style&index=1&id=300d4346&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300d4346"],['__file',"src/components/shared/Modals/IFSModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "300d4346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('300d4346', __exports__)) {
    api.reload('300d4346', __exports__)
  }
  
  module.hot.accept("./IFSModal.vue?vue&type=template&id=300d4346&scoped=true", () => {
    api.rerender('300d4346', render)
  })

}


export default __exports__